<script>
import { Account, Location, ShoppingCart, util } from './../../functions.js'

import AccountAPI from './../../api/account.js'
import ProductAPI from './../../api/product.js'

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'
import AddressFormModal from './../shared/AddressFormModal.vue'
import AddToCartModal from './../shared/AddToCartModal.vue'
import AlertModal from './../shared/AlertModal.vue'

import ConfirmDialogue from './../shared/ConfirmDialogue.vue'
import AlertDialogue from './../shared/AlertDialogue.vue'

import AddToCartDialogue from './../shared/AddToCartDialogue.vue'
import QuickviewDialogue from './../shared/QuickviewDialogue.vue'

import { _toNumber, _uniqBy, _orderBy } from 'lodash';

export default {
  name: 'Account',
  components: {
    Footer,
    HeaderFive,
    AddressFormModal,
    AddToCartModal,
    AlertModal,
    ConfirmDialogue,
    AlertDialogue,
    AddToCartDialogue,
    QuickviewDialogue
  },
   beforeRouteLeave(to, from, next) {
       var is_temp_password = Account.getPasswordStatus();
       if(is_temp_password)
       {
          this.$refs.alertDialogue.show({
               title: "Update your Password",
              message: "Please change your password first before leaving",
              okButton: 'OK',
              buttonLayout: 'not-block'
          });
           return false;
       }
       else
       {
         return next();
       }
  },
  watch: {
    error_message (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value != '') {
        setTimeout(() => {
          this.show_error = false;
          this.show_changepass_error = false;
          this.error_message = ''
        }, 10000)
      }
    }
  },
  data () {
    return {
        Account,
        show_error: false,
        submitting_accountdetails: false,
        show_changepass_error: false,
        submitting_changepassword: false,
        error_message: '',
        active_tab: 'orders',
        uuid: '',
        temp_pass: false,
        first_name: '',
        last_name: '',
        mobile_number: '',
        email_address: '',
        sec_registration_number: '',
        sec_registration_file: [],
        sec_registration_filelink: '',
        dti_registration_number: '',
        dti_registration_file: [],
        dti_registration_filelink: '',
        tin_filelink: '',
        tin_number: '',
        tin_file: [],
        doc1_filelink: '', //New Added for addional document
        doc2_filelink: '', //New Added for addional document
        doc3_filelink: '', //New Added for addional document
        additional_documents: [], // Array for document names
        additional_documents_file: [], // Array for file objects
        additional_document_count: 3, // for new set of additional document to appear
        links: [], //New added for links
        linkInput: '', //New Added for Link Input
        classificationData: [], //New Added Customer Classification`
        channel_classification: '', //New Added Customer Classification`
        registered_business_name: '',
        trader_name: '',
        position: '',
        tel_number: '',
        referrer_code: '',
        addresses: [],
        confirm_password: '',
        new_password: '',
        current_password: '',
        show_confirm_password: false,
        show_new_password: false,
        show_current_password: false,
        address_data: null,
        address_index: 0,
        address_form_mode: 'add',
        show_address_form: false,
        vouchers: [],
        orders: [],
        paged_orders: [],
        view_order: false,
        viewed_order: null,
        added_product : null,
        showAddToCart : false,
        showAlert : false,
        modal_status: "success",
        modal_custom_message: "",
        itemPerPage: 20,
          currentPage: 1,
          maxPage: 1,
          pageList: [],
    }
  },
  // NEW ADDED FOR LINKS TEXTBOX FIELD START//
  computed: {
    linksText: {
      // Display the links in the textarea, separated by newlines
      get() {
        return this.links.join('\n');
      },
      set(newValue) {
        if (typeof newValue === 'string') {
          this.links = newValue.split('\n').filter(link => link.trim() !== '');
        } else {
          this.links = [];  // Fallback in case newValue is not a string
        }
}
    }
  },
  mounted() {
    // When the component is mounted, populate linkInput with the current links
    this.linkInput = this.linksText;
    this.getCustomerClassification();
  },

  onMounted() {
    this.linkInput = this.linksText;
    
  },

  // NEW ADDED FOR LINKS TEXTBOX FIELD END//
  
  methods: {
      //New Added Getting List of Customer Classification  Start

      async getCustomerClassification() {
      try {
        const response = await AccountAPI.customerClassification();  // No need for .then()
        
        if (response) {
          this.classificationData = response.data
        } else {
          console.log('Error in Getting the Customer Classification');
        }
      } catch (error) {
        console.log('Something went wrong in the request:', error);
   
      }
    },
      //New Added Getting List of Customer Classification  End

    setTab(tab)
    {
      this.active_tab   = tab;
      this.$router.replace({ name: 'account', params: {'tab': tab }});
    },
    numericOnly(e)
    {
      var charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
       
    },
   uploadAttachments(file_var, uuid, upload_type)
    {
      if(file_var == null) {
        return false;
      }
      else
      {
        var submit_files = AccountAPI.submitAttachments(
          file_var[0].fileObject.type,
          file_var[0].fileObject.name,
          file_var[0].dataURL, uuid, upload_type);
        submit_files.then((response)=>{

        });
      }
    },
   uploadSecRegFile(event)
  {
    // fixme: event does not get triggered if same photo is reselected
    if(!event.target.files.length) return;

 
    let files = (event.target.files); // Do not exceed this.MAX_IMAGE
    
    // Allow multiple upload
    for(let i = 0; i < files.length; ++i) {
      // Read and add to this.images
      let file = files[i]
      let reader = new FileReader()

      reader.onload = (e) => {
        // insert
        this.sec_registration_file.push({
          fileObject: file,
          dataURL: e.target.result
        });
        this.sec_file_base64 = e.target.result;
      }

      reader.readAsDataURL(file)
    }
  },
   uploadDtiRegFile(event)
  {
    // fixme: event does not get triggered if same photo is reselected
    if(!event.target.files.length) return;

 
    let files = (event.target.files); // Do not exceed this.MAX_IMAGE
    // Allow multiple upload
    for(let i = 0; i < files.length; i++) {
      // Read and add to this.images
      let file = files[i]
      let reader = new FileReader()

      reader.onload = (e) => {
        // insert
        this.dti_registration_file.push({
          fileObject: file,
          dataURL: e.target.result
        })
      }

      reader.readAsDataURL(file)
    }
  },
  uploadTinFile(event)
  {
    // fixme: event does not get triggered if same photo is reselected
    if(!event.target.files.length) return;

 
    let files = (event.target.files); // Do not exceed this.MAX_IMAGE
    
    // Allow multiple upload
    for(let i = 0; i < files.length; ++i) {
      // Read and add to this.images
      let file = files[i]
      let reader = new FileReader()

      reader.onload = (e) => {
        // insert
        this.tin_file.push({
          fileObject: file,
          dataURL: e.target.result
        })
      }

      reader.readAsDataURL(file)
    }
  },

    //New Added Additional Documents Start
    uploadAdditionalFile(index, event) {
      if (!event.target.files.length) return;

      const files = Array.from(event.target.files);
      this.additional_documents_file[index] = this.additional_documents_file[index] || []; // Initialize the array if not already

      for (const file of files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.additional_documents_file[index].push({
            fileObject: file,
            dataURL: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      }
    },
    addFile() {
      if (this.additional_document_count < 3) {
        this.additional_document_count += 1;
        this.additional_documents.push(''); // Add a new entry for the document name
        this.additional_documents_file.push([]); // Initialize an array for the new document's files
      }
    },

  //New Added Additional Documents End
  
    resetAddressFormModal(message, status)
    {
        this.show_error = true;
        this.error_message = message;
        this.show_address_form = false;
        this.address_form_mode = "add";
        this.address_data = null;
        this.address_index = 0;
    },
    addNewAddress()
    {
        this.address_form_mode = "add";
        this.show_address_form = true;
    },
    editAddress(address, index)
    {
        this.address_form_mode = "edit";
        this.address_data = address;
        this.show_address_form = true;
        this.address_index = index;
    },
    removeAddress(address, index)
    {
        this.address_form_mode = "remove";
        this.address_data = address;
        this.show_address_form = true;
        this.address_index = index;
    },
    async logout()
    {
      var is_temp_password = Account.getPasswordStatus();
      if(is_temp_password)
      {
          await this.$refs.alertDialogue.show({
               title: "Update your Password",
              message: "Please change your password first before signing out",
              okButton: 'OK',
              buttonLayout: 'not-block'
          });
      }
      else
      {
        var do_logout = await this.$refs.confirmDialogue.show({
               title: "Are you sure you want to Sign out?",
              message: " ",
              okButton: 'Yes',
              cancelButton: 'No',
              buttonLayout: 'not-block'
          });

        if(do_logout)
        {
          var token = this.Account.getToken();
          var logout_request = AccountAPI.logout(token)
          logout_request.then((response)=>{
            this.Account.setToken('');
            this.Account.setLoginId('');
            this.Account.setCustomerID('');
            
                this.Account.setAddresses([]);
            this.$router.push({ name: "login", query: { 'm' :"user_logout"}})
          });
        }
      }
       
    },
    async loadAccountVouchers()
    {
      try {
          var login_id = Account.getLoginId();
          var token = Account.getToken();
          var accountvoucher_request = AccountAPI.myVouchers(login_id, token);
          accountvoucher_request.then((response) =>{
              if(response.status == 'success')
              {
                this.vouchers = response.voucher_info;
              }
          });
      } catch (error) {
          console.log(error);
      }
    },
    async loadOrders()
    {
      try {
          this.orders = [];
          var login_id = Account.getLoginId();
          var token = Account.getToken();
          var customer_id = Account.getCustomerID();
          var from = '';
          var to = '';
          var accountorders_request = AccountAPI.myOrders(login_id, token, from, to);
          accountorders_request.then((response) =>{
              if(response.status == 'success')
              {
                for (const key in response.data) {
                  this.orders.push(response.data[key]);

                }

                // this.orders = _.reverse(this.orders);
               this.orders = _.orderBy(this.orders, ['details.order_id'], 
             ['desc']);
               this.loadPagination();
                console.log(this.orders);
              }
          });
      } catch (error) {
          console.log(error);
      }
    },
    async loadAccountDetails()
    {
      try {
          var token = this.Account.getToken();
          var customer_id = this.Account.getCustomerID();
          var account_info_request = AccountAPI.accountInfo(token, customer_id);
          account_info_request.then((response) =>{
              if((response.data))
              {

                  this.uuid = (response.data.uuid ? response.data.uuid : '');
                  this.temp_pass = response.temp_pass;
                  this.first_name = response.data.first_name;
                  this.last_name = response.data.last_name;
                  this.tel_number = (response.data.telephone_number ? response.data.telephone_number : '');
                  this.position = (response.data.position ? response.data.position : '');
                  this.mobile_number = (response.data.mobile_number ? response.data.mobile_number : '');
                  this.email_address = response.data.email;
                  //this.addresses = response.data.addresses;
                  this.referrer_code = response.data.referrer_code;

                  this.sec_registration_number = response.data.sec_reg_no;
                  this.dti_registration_number = response.data.dti_reg_no;
                  this.tin_number = response.data.tin_no;

                  if (response.data.doc1) {
                    this.additional_documents[0] = response.data.doc1;
                  }

                  if (response.data.doc2) {
                    this.additional_documents[1] = response.data.doc2;
                  }

                  if (response.data.doc3) {
                    this.additional_documents[2] = response.data.doc3;
                  }
                  
                  this.trader_name = (response.data.trader_name? response.data.trader_name : '');
                  this.registered_business_name = (response.data.registerd_business_address ? response.data.registerd_business_address : '' );
                  
                  this.tin_filelink = response.data.tin_no_file;
                  this.dti_registration_filelink = response.data.dti_reg_no_file;
                  this.sec_registration_filelink = response.data.sec_reg_no_file;
                  this.doc1_filelink = response.data.doc1_file || '';
                  this.doc2_filelink = response.data.doc2_file || '';
                  this.doc3_filelink = response.data.doc3_file || '';
                  
                  this.channel_classification = (response.data.class_code? response.data.class_code : ''); //NEW ADDED CUSTOMER CHANNEL CLASSIFICATION
                  this.links = Array.isArray(response.data.links) ? response.data.links : []; //NEW ADDED FOR LINKS
                  this.linkInput = this.linksText; 
                  
                  this.addresses = Account.getAddresses();
                  this.Account.setInfo(response.data);

                  var test_datauri = "";
                  var test_filename = '';
                  var test_type = '';  
              }
            
              else
              {
                  this.logout();
              }
          });
      } catch (error) {
        console.log(error);
          this.logout();
      }
    },
    validateAccountDetails () {
        var error = {
            message: '',
            has_error: 0
        }

        if (this.registered_business_name.trim() == '' || this.registered_business_name == null) {
            error.message = 'Please enter your Registered Business Name'
            error.has_error = 1
            return error
        }
        else if (this.first_name.trim() == '' || this.first_name == null) {
            error.message = 'Please enter your First Name'
            error.has_error = 1
            return error
        } else if (this.last_name.trim() == '' || this.last_name == null) {
            error.message = 'Please enter your Last Name'
            error.has_error = 1
            return error
        }  
        else if (this.position.trim() == '' || this.position == null) {
            error.message = 'Please enter your Position'
            error.has_error = 1
            return error
        } 
         else if (this.tel_number.trim() == '' || this.tel_number == null) {
            error.message = 'Please enter your Telephone Number'
            error.has_error = 1
            return error
        } 
         else if( !(/\d{7}$/).test(this.tel_number) )
          {
             error.message = 'Please enter a valid Telephone Number'
            error.has_error = 1
            return error
          }
        else if (this.mobile_number.trim() == '' || this.mobile_number == null) {
            error.message = 'Please enter your Mobile Number'
            error.has_error = 1
            return error
        } 
        else if( !(/^(09|639)\d{9}$/).test(this.mobile_number) )
          {
             error.message = 'Please enter a valid Mobile Number'
            error.has_error = 1
            return error
          }
          else if (this.email_address.trim() == '' || this.email_address == null) {
            error.message = 'Please enter your Email Address'
            error.has_error = 1
            return error
          } else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_address))) {
            error.message = 'Please enter a valid Email Address'
            error.has_error = 1
            return error
          } 
          else if (this.channel_classification.trim() == '' || this.channel_classification == null) {
            error.message = 'Please select channel classification'
            error.has_error = 1
            return error
        }

        return error
    },
    async updateAccountDetails()
    {
        this.show_error = false
        this.error_message = ''

        var validation = this.validateAccountDetails()
        if (validation.has_error) {
            this.show_error = true
            this.error_message = validation.message

                    this.$refs['account_form'].scrollIntoView({ behavior: 'smooth', block: "center" });

        } else {
            try {
                const separators = /[,\s\n]+/;
                this.links = this.linkInput.split(separators).filter(link => link.trim() !== '');
                this.linkInput = this.links.join('\n');
                const doc1 = this.additional_documents[0] || '';
                const doc2 = this.additional_documents[1] || '';
                const doc3 = this.additional_documents[2] || '';
                this.submitting_accountdetails = true;
                var login_id = this.Account.getLoginId();
                var token = this.Account.getToken();
                var customer_id = this.Account.getCustomerID();
                var update_details_request = AccountAPI.updateAccountInfo(
                  login_id,
                  token,
                  customer_id,
                  this.registered_business_name,
                  this.trader_name,
                  this.sec_registration_number,
                  this.dti_registration_number,
                  this.tin_number,
                  this.first_name,
                  this.last_name,
                  this.position,
                  this.tel_number,
                  this.mobile_number,
                  this.email_address,
                  this.channel_classification, //NEW ADDED FOR USER CHANNEL CLASSIFICATION
                  this.links,
                  doc1,
                  doc2,
                  doc3
                  
                ); //NEW ADDED FOR LINKS IN ARRAY
                update_details_request.then((response) =>{
                if(response.status == 'success' || response.status == 'Success')
                {

                      if(this.sec_registration_file.length)
                      {
                        this.uploadAttachments(this.sec_registration_file,this.uuid, 'SEC_REG');
                      }

                      if(this.dti_registration_file.length)
                      {
                        this.uploadAttachments(this.dti_registration_file,this.uuid, 'DTI_REG');
                      }

                      if(this.tin_file.length)
                      {
                        this.uploadAttachments(this.tin_file,this.uuid, 'TIN_NUM');
                      }
                      this.additional_documents.forEach((doc, index) => {
                        if (this.additional_documents_file[index] && this.additional_documents_file[index].length) {
                          this.uploadAttachments(this.additional_documents_file[index], this.uuid, `docs${index + 1}`);
                        }
                      });

                      

                    this.show_error = true;
                    this.error_message = response.message;
                    this.$refs['account_form'].scrollIntoView({ behavior: 'smooth', block: "center" });


                }
                else
                {
                    this.show_error = true;
                    this.error_message = response.message;

                    this.$refs['account_form'].scrollIntoView({ behavior: 'smooth', block: "center" });
                }
                this.submitting_accountdetails = false;
            });
            } catch (error) {
                console.log(error);
                this.submitting_accountdetails = false;
                this.show_error = true;
                this.error_message = error;

                    this.$refs['account_form'].scrollIntoView({ behavior: 'smooth', block: "center" });
            }
        }
    },
    validateChangePassword () {
        var error = {
            message: '',
            has_error: 0
        }

        if (this.current_password == '' || this.current_password == null) {
            error.message = 'Please enter your current password'
            error.has_error = 1
            return error
        } else if (this.new_password == '' || this.new_password == null) {
            error.message = 'Please enter your new password'
            error.has_error = 1
            return error
        }  else if (this.confirm_password == '' || this.confirm_password == null) {
            error.message = 'Please confirm your new password'
            error.has_error = 1
            return error
        }  else if (this.confirm_password != this.new_password) {
            error.message = "Password doesn't match. Please re-enter your password"
            error.has_error = 1
            return error
        } 

        return error
    },
    async changePassword()
    {
        if(this.current_password == '' && this.new_password == '' && this.current_password == '')
        {
            // Don't do anything.
        }
        else
        {
            this.show_changepass_error = false
            this.error_message = ''

            var validation = this.validateChangePassword()
            if (validation.has_error) {
                this.show_changepass_error = true
                this.error_message = validation.message

            } else {
                try {
                    this.submitting_changepassword = true;
                    var login_id = this.Account.getLoginId();
                    var token = this.Account.getToken();
                    var changepassword_request = AccountAPI.accountChangePassword(login_id, token, this.current_password, this.new_password, this.confirm_password);
                    changepassword_request.then((response) =>{
                         if(response.status == 'success' || response.status == 'Success.')
                         {
                            this.show_changepass_error = true;
                            this.error_message = response.message;
                            Account.setPasswordStatus(false);

                            this.current_password = '';
                            this.new_password = '';
                            this.confirm_password = '';
                         }
                         else
                         {
                            this.show_changepass_error = true;
                            for (const fields in response.errors) {
                              
                              response.errors[fields].forEach((error, error_key)=>{
                                  this.error_message = error;
                              });
                            }

                         }
                        const container = document.getElementById("changepass_section");
                        container.scrollIntoView({ behavior: 'smooth' , block: 'center'})
                    this.submitting_changepassword = false;
                });
                } catch (error) {
                    console.log(error);
                    this.submitting_changepassword = false;
                    this.show_changepass_error = true
                    this.error_message = error
                }
            }

        }
    },
    async viewOrder(order_id)
    {
        try {
          var login_id = Account.getLoginId();
          var token = Account.getToken();
          var customer_id = Account.getCustomerID();
          var vieworder_request = AccountAPI.getOrderDetails(customer_id, token, order_id);
          vieworder_request.then((response) =>{
              if(response.status == 'success')
              {
                this.viewed_order = response.data;

                // Transform Free Items Data
                var free_items = [];
                this.viewed_order.products.free_items.forEach((free, free_index)=>{
                  var item_index = null;
                  var added_quantity = 0;

                  free_items.forEach((fi, fi_index)=>{
                    if(free.product_name == fi.product_name)
                    {
                      item_index = fi_index;
                      added_quantity = parseInt(fi.quantity);
                    }
                  });

                  if(item_index == null)
                  {
                    free_items.push(free);
                  }
                  else
                  {
                    free_items[item_index].quantity = parseInt(free_items[item_index].quantity) + parseInt(added_quantity);
                  }
                });

                this.viewed_order.products.free_items = free_items;
                this.viewed_order.purchaseData.free_items = free_items;


                this.view_order = true;
              }

              console.log(this.orders);
          });
      } catch (error) {
          console.log(error);
      }

    },
    resetViewOrder()
    {
        this.view_order = false;
        this.viewed_order = null;
    },
    purchaseAgain(sku_id, quantity)
    {
        try {
          var barangay_code = Location.location.barangay.brgy_code;
          var product_info_request = ProductAPI.getProductDetails(barangay_code, sku_id);
          product_info_request.then((response) =>{
             this.added_product = response.product;
            if(response.status)
            {
               
                ShoppingCart.addToCart(this.added_product, 1).then((response)=>{
                    this.modal_status = (response.status == 'success' ? 'success' : 'failed');
                    this.modal_custom_message = (response.status == 'success' ? '' : response.message);
                    var add_cart = this.$refs.addToCartDialogue.show({
                        product: this.added_product,
                        status: this.modal_status,
                        message: this.modal_custom_message,
                        // okButton: 'Back to Home',
                   
                    });
                });
            }
            else
            {
                if((response.msg).toLowerCase() == 'not_found')
                {
                    this.modal_status = 'failed';
                    this.modal_custom_message = "Product cannot be found in your selected delivery address";
                    // this.showAlert = true;
                       this.$refs.alertDialogue.show({
                        title: "Unable to Add Product",
                        message: this.modal_custom_message,
                        okButton: 'OK',
                    });
                }
                else
                {
                    this.modal_status = 'failed';
                    this.modal_custom_message = response.msg;
                    // this.showAlert = true;

                   this.$refs.alertDialogue.show({
                        title: "Unable to Add Product",
                        message: response.msg,
                        okButton: 'OK',
                    });
                }
            }
          });
      } catch (error) {
          console.log(error);
      }

    },
    loadPagination () {
      var pagination = []
    
      this.maxPage = Math.ceil( this.orders.length / this.itemPerPage);
      for (var i = 1; i <= this.maxPage; i++) {
        pagination.push(i)
      }

   
      this.paged_orders = this.orders.slice(((this.currentPage - 1) * this.itemPerPage), (this.currentPage * this.itemPerPage));
      this.pageList = pagination
    },
    prevPage () {
      if (this.currentPage > 1) 
        {
           this.currentPage = this.currentPage - 1 ;
           this.paged_orders = this.orders.slice(((this.currentPage - 1) * this.itemPerPage), (this.currentPage * this.itemPerPage));
         }
    },
    nextPage () {
      if (this.currentPage < (this.orders.length / this.itemPerPage)) {
       this.currentPage = this.currentPage + 1;
       this.paged_orders = this.orders.slice(((this.currentPage - 1) * this.itemPerPage), (this.currentPage * this.itemPerPage));
      }
    },
    goToPage (page) {
      if (page >= 1 && page <= this.maxPage) {
        this.currentPage = page;
        this.paged_orders = this.orders.slice(((this.currentPage - 1) * this.itemPerPage), (this.currentPage * this.itemPerPage));
      }
    },
  },
  created() {
      this.loadAccountDetails();
      this.loadAccountVouchers();
      this.loadOrders();

      this.active_tab = (this.$route.params.tab ? this.$route.params.tab :this.active_tab);
  }
}
</script>

<template>
  <div class="page account-page">
      <HeaderFive />

      <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white  bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                            <!-- <h6 class="section-subtitle ltn__secondary-color">//  Welcome to our company</h6> -->
                            <h1 class="section-title white-color">My Account</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/"> Home</router-link></li>
                                <li>My Account</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- WISHLIST AREA START -->
    <div class="liton__wishlist-area pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <!-- PRODUCT TAB AREA START -->
                    <div class="ltn__product-tab-area">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="ltn__tab-menu-list mb-50">
                                        <div class="nav">
                                           <!-- <a data-toggle="tab" href="#liton_tab_1_1" @click="setTab('dashboard')" :class="{'active show': active_tab == 'dashboard'}">Dashboard <i class="fas fa-home"></i></a> -->
                                            <a data-toggle="tab" href="#liton_tab_1_2" @click="setTab('orders')" :class="{'active show': active_tab == 'orders'}">Orders <i class="fas fa-file-alt"></i></a>
                                             <!-- <a data-toggle="tab" href="#liton_tab_1_3" @click="setTab('vouchers')"Account :class="{'active show': active_tab == 'vouchers'}">Vouchers <i class="fas fa-percent"></i></a> -->
                                            <a data-toggle="tab" href="#liton_tab_1_4" @click="setTab('addresses')" :class="{'active show': active_tab == 'addresses'}">Addresses <i class="fas fa-map-marker-alt"></i></a>
                                            <a data-toggle="tab" href="#liton_tab_1_5" @click="setTab('info')" :class="{'active show': active_tab == 'info'}">Account Details <i class="fas fa-user"></i></a>
                                            <a data-toggle="tab" href="#liton_tab_1_6" @click="logout">Logout <i class="fas fa-sign-out-alt"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="tab-content">
                                        <div class="tab-pane fade" :class="{'active show': active_tab == 'dashboard'}" id="liton_tab_1_1">
                                            <div class="ltn__myaccount-tab-content-inner">
                                                <p>Hello <strong>{{ first_name }}</strong> <small style="cursor:pointer; color: blue;">(<a @click="logout">Log out</a>)</small></p>
                                                <p>From your account dashboard you can view your <span>recent orders</span>, manage your <span>shipping and billing addresses</span>, and <span>edit your password and account details</span>.</p>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" :class="{'active show': active_tab == 'orders'}" id="liton_tab_1_2">
                                            <div class="ltn__myaccount-tab-content-inner">
                                                <h2>My Orders</h2>
                                                 <p v-if="!orders.length">No Orders Found</p>
                                                 <div class="orders" v-if="orders.length">
                                                     <div class="order-list" v-if="!view_order">
                                                        <div class="table-responsive" >
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Order</th>
                                                                        <th>Date</th>
                                                                        <th>Ship To</th>
                                                                        <th>Status</th>
                                                                        <th>Total</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                 
                                                                    <tr v-for="order in paged_orders">
                                                                        <td>{{ order.details.order_id }}</td>
                                                                        <td>{{ order.details.date }}</td>
                                                                        <td><p class="text-truncate">{{ order.details.ship_to }}</p></td>
                                                                        <td>{{ order.details.status.label }}</td>
                                                                        <td> {{ (order.price_breakdown.total) | currencyFormat}}</td>
                                                                        <td><a class="exaggerated_link" @click="viewOrder(order.details.order_id)">View Order</a></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div class="ltn__pagination-area text-center" v-if="orders.length">
                                                            <div class="ltn__pagination">
                                                                <ul>
                                                                    <li><a @click="prevPage"><i class="fas fa-angle-double-left"></i></a></li>
                                                                    <li v-for="page of pageList.length" :class="{'active' : currentPage == page }"><a @click="goToPage(page)">{{ page }}</a></li>
                                                                    <li><a @click="nextPage"><i class="fas fa-angle-double-right"></i></a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="order-details" v-if="view_order">
                                                        <div class=" order-details-body mb-5">
                                                             <div class="row">
                                                                <div class="col-4">
                                                                    Status
                                                                </div>
                                                                <div class="col-8">
                                                                    {{ viewed_order.details.status.label }}
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-4">
                                                                    Order ID
                                                                </div>
                                                                <div class="col-8">
                                                                   {{ viewed_order.details.order_id }}
                                                                </div>
                                                            </div>
                                                             <div class="row ">
                                                                <div class="col-4">
                                                                    Order Placed
                                                                </div>
                                                                <div class="col-8">
                                                                    {{ viewed_order.details.date }}
                                                                </div>
                                                            </div>
                                                             <div class="row ">
                                                                <div class="col-4">
                                                                    Actual Delivery Date
                                                                </div>
                                                                <div class="col-8">
                          

                                                                   {{  viewed_order.details.pickup_method == 'Scheduled Delivery' ? (((viewed_order.details.status.label).toLowerCase() == "completed" || 
                                                                      (viewed_order.details.status.label).toLowerCase() == "cancelled" || 
                                                                      (viewed_order.details.status.label).toLowerCase() == "ready for delivery") ? (viewed_order.details.apickup_date)  : '') : viewed_order.details.apickup_date }}
                                                           
                                                                </div>
                                                            </div>
                                                             <div class="row ">
                                                                <div class="col-4">
                                                                    Delivery Location
                                                                </div>
                                                                <div class="col-8">
                                                                    {{ viewed_order.details.ship_to }}
                                                                </div>
                                                            </div>
                                                            <div class="row ">
                                                                <div class="col-4">
                                                                    Subtotal
                                                                </div>
                                                                <div class="col-8">
                                                                    {{ viewed_order.price_breakdown.product - viewed_order.price_breakdown.cart_discount | currencyFormat }}
                                                                </div>
                                                            </div>
                                                            
                                                            <div class="row">
                                                                <div class="col-4">
                                                                    Shipping Fee
                                                                </div>
                                                                <div class="col-8">
                                                                    {{ viewed_order.price_breakdown.shipping | currencyFormat }}
                                                                </div>
                                                            </div>
                                                      
                                                            <div class="row">
                                                                <div class="col-4">
                                                                    Total
                                                                </div>
                                                                <div class="col-8">
                                                                    {{ (viewed_order.price_breakdown.total) | currencyFormat}}
                                                                </div>
                                                            </div>
                                                             <div class="row" v-if="viewed_order.details.promo_avail.length">
                                                                <div class="col-4">
                                                                    Discounts Applied
                                                                </div>
                                                                <div class="col-8">
                                                                    
                                                                </div>
                                                            </div>
                                                            <div class="row" v-if="viewed_order.details.promo_avail.length" v-for="promo in viewed_order.details.promo_avail">
                                                                <div class="col-4 text-primary">
                                                                    {{ promo.promo_desc }}
                                                                </div>
                                                                <div class="col-8">
                                                                    
                                                                </div>
                                                            </div>
                                                             <div class="row" v-if="viewed_order.details.voucher_avail.length">
                                                                <div class="col-4">
                                                                    Voucher Applied
                                                                </div>
                                                                <div class="col-8">
                                                                    
                                                                </div>
                                                            </div>
                                                            <div class="row" v-if="viewed_order.details.voucher_avail.length" v-for="promo in viewed_order.details.voucher_avail">
                                                                <div class="col-4 text-primary">
                                                                    {{ promo.promo_desc }}
                                                                </div>
                                                                <div class="col-8">
                                                                    
                                                                </div>
                                                            </div>
                                                             <div class="row" v-if="viewed_order.details.invoice_filename != ''">
                                                                <div class="col-4">
                                                                    Invoice
                                                                </div>
                                                                <div class="col-8">
                                                                    <a style="color: blue;" :href="viewed_order.details.invoice_filename" target="_blank">Download Here</a>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-8">
                                                                 <h4 class="mt-4">Products</h4>
                                                              </div> 
                                                            </div>
                                                            <div class="row" v-for="product in viewed_order.products.data">
                                                                <div class="col-4">
                                                                    {{ product.name }} x {{ product.quantity }}
                                                                </div>  
                                                                 <div class="col-2">
                                                                     <span>{{ ( (product.sale_type == 'fixed' || product.sale_type == 'percentage') ? (product.total) : (product.total)) | currencyFormat }}</span><br>
                                                                    <del v-if="product.sale_type == 'fixed' || product.sale_type == 'percentage'">{{ product.regular_price * product.quantity | currencyFormat }}</del>
                                                                </div>
                                                                <div class="col-6">
                                                                    <button type="button" @click="purchaseAgain(product.sku, product.quantity)">Add to Cart</button>
                                                                    <AddToCartModal :product="added_product" :status="modal_status" :message="modal_custom_message" v-if="showAddToCart"  @onClose="showAddToCart = false" />
                                                                    <AlertModal :status="modal_status" :message="modal_custom_message" v-if="showAlert"  @onClose="showAlert = false" />
                                                                </div>
                                                            </div>
                                                            <div class="row" v-for="free in viewed_order.products.free_items">
                                                                <div class="col-4">
                                                                    {{ free.product_name }} x {{ free.quantity }}
                                                                </div>  
                                                                 <div class="col-2">
                                                                     FREE
                                                                </div>
                                                                <div class="col-6">
                                                              
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="btn-wrapper mt-0 text-center">
                                                            <button class="btn theme-btn-1 btn-effect-1 text-uppercase" type="button" @click="resetViewOrder">Back</button>
                                                        </div>
                                                    </div>
                                                   
                                               
                                           
                                                 </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" :class="{'active show': active_tab == 'vouchers'}" id="liton_tab_1_3">
                                            <div class="ltn__myaccount-tab-content-inner">
                                                <h2>My Vouchers</h2>
                                                <div class="row" v-if="vouchers.length">
                                                    <div class="voucher-item col-12 col-sm-6" v-for="voucher in vouchers">
                                                       {{ voucher.status == 1  ? 'available' : 'expired'}}
                                                          {{ voucher.voucher_code }}

                                                                <button
                                                                  >Copy</button>
                                                             
                                                                 {{ voucher.voucher_description }}
                                                            
                                                                  Valid Until: <!-- {{ voucher.voucher_start_date | date }} to --> {{ voucher.voucher_end_date }}
                                                            
                                                    </div>
                                                </div>
                                                <p v-if="!vouchers.length">No Vouchers Found</p>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" :class="{'active show': active_tab == 'addresses'}" id="liton_tab_1_4">
                                            <div class="ltn__myaccount-tab-content-inner">
                                                <p>The following addresses will be used on the checkout page by default.</p>
                                                <p v-if="show_error && error_message">{{ error_message }}</p>
                                                <div class="row">
                                                   
                                                    <div class="col-md-12 col-12 learts-mb-30">
                                                        <h4>My Address</h4>
                                                        <div class="address-list"  v-if="addresses.length">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <address class="address" v-for="(address,index) in addresses">
                                                                        <p>
                                                                            {{ address.addresses }}, {{ address.brgy_name }}, {{ address.city_name }}, {{ address.province_name }} <br>
                                                                           
                                                                        </p>
                                                                    </address>
                                                                </div>
                                                                <!-- <div class="col-12 col-md-4">
                                                                    <a @click="editAddress(address, index)">Edit</a>
                                                                    <a @click="removeAddress(address, index)">Remove</a>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                        <div class="address-list no-address" v-if="!addresses.length">
                                                            <p>No Address Found</p>
                                                        </div>
                                                        <button type="submit" @click="addNewAddress" class="btn theme-btn-1 btn-effect-1 text-uppercase">{{ 'Add New Address' }}</button>
                                                       <AddressFormModal v-if="show_address_form" :mode="address_form_mode" :selected_address="address_data" :selected_index="address_index" @onClose="resetAddressFormModal" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" :class="{'active show': active_tab == 'info'}" id="liton_tab_1_5">
                                            <div class="ltn__myaccount-tab-content-inner">
                                                <h2 ref="account_form">Account Details</h2>
                                                <!-- <p>The following addresses will be used on the checkout page by default.</p> -->
                                                <p v-if="show_error">{{ error_message }}</p>
                                                <div class="ltn__form-box">
                                                    <div class="mb-50">
                                                        <div class="row ">
                                                            <div class="col-lg-6">
                                                                <div>
                                                                    <label>Registered Business Name:</label>
                                                                    <input type="text" v-model="registered_business_name" name="ltn__registered_business_name">
                                                                </div>
                                                                <div>
                                                                    <label>Trade Name:</label>
                                                                    <input type="text" v-model="trader_name" name="ltn__trader_name">
                                                                </div>
                                                                <!-- NEW ADDED FOR CHANNEL CLASSIFICATION START-->
                                                                <div>
                                                                    <label for="channel_classification">Channel Classification</label>
                                                                    <select v-model="channel_classification" id="channel_classification" class="c-select" required>
                                                                        <option selected disabled value="">Select Channel Classification</option>
                                                                        <option v-for="classification in classificationData" :key="classification.code" :value="classification.code">
                                                                        {{ classification.name }}
                                                                        </option>
                                                                    </select>
                                                                    </div>
                                                                <!-- NEW ADDED FOR CHANNEL CLASSIFICATION END-->
                                                                 <div>
                                                                    <label>SEC Registration Number</label>
                                                                    <input type="text" ref="secfile" v-model="sec_registration_number" name="ltn__sec_registration_number">
                                                                 
                                                                </div>
                                                                <div>
                                                                      <label>SEC Registration File</label>
                                                                      <div>
                                                                        <a v-if="sec_registration_filelink != ''" :href="sec_registration_filelink" style="color: blue; cursor: pointer; font-weight: bold;" target="_blank">Download Here</a>
                                                                        <span v-if="sec_registration_filelink == ''"> No Attachment Found</span>
                                                                      </div>
                                                                        <br>
                                                                    <label>Upload New File</label>
                                                                    <input type="file" @change="uploadSecRegFile" class="mb-50" name="ltn__sec_registration_file">
                                                                </div>
                                                                <div>
                                                                    <label>DTI Registration Number</label>
                                                                    <input type="text" v-model="dti_registration_number"  name="ltn__dti_registration_number" v-on:keypress="numericOnly($event)">
                                                                </div>
                                                                <div>
                                                                   <label>DTI Registration File</label>
                                                                    <div>
                                                                        <a v-if="dti_registration_filelink != ''" :href="dti_registration_filelink" style="color: blue; cursor: pointer; font-weight: bold;" target="_blank">Download Here</a>
                                                                        <span v-if="dti_registration_filelink == ''"> No Attachment Found</span>
                                                                      </div>
                                                                        <br>
                                                                     <label>Upload New File</label>
                                                                    <input type="file" @change="uploadDtiRegFile" class="mb-50" name="ltn__dti_registration_file">
                                                                </div>
                                                                <div>
                                                                    <label>TIN Number</label>
                                                                    <input type="text" v-model="tin_number" name="ltn__tin_number" v-on:keypress="numericOnly($event)">
                                                                </div>
                                                                <div>
                                                                     <label>TIN File</label>
                                                                      <div>
                                                                        <a v-if="tin_filelink != ''" :href="tin_filelink" style="color: blue; cursor: pointer; font-weight: bold;" target="_blank">Download Here</a>
                                                                        <span v-if="tin_filelink == ''"> No Attachment Found</span>
                                                                      </div>
                                                                        <br>
                                                                     <label>Upload New File</label>
                                                                    <input type="file" @change="uploadTinFile" class="mb-50" name="ltn__tin_file">
                                                                </div>
                                                                <!--- New Added Additional Document Start -->
                                                               <!-- Additional Document 1 -->
                                                                <div>
                                                                  <label>Additional Document 1</label>
                                                                  <input
                                                                    type="text"
                                                                    class="mb-10"
                                                                    name="additional_document1"
                                                                    id="additional_document1"
                                                                    v-model.lazy="additional_documents[0]"
                                                                  />
                                                                </div>
                                                                <div>
                                                                  <div>
                                                                    <a 
                                                                      v-if="doc1_filelink !== ''" 
                                                                      :href="doc1_filelink" 
                                                                      style="color: blue; cursor: pointer; font-weight: bold;" 
                                                                      target="_blank"
                                                                    >
                                                                      Download Here
                                                                    </a>
                                                                    <span v-if="doc1_filelink === ''"> No Attachment Found</span>
                                                                  </div>
                                                                  <br>
                                                                  <label for="additional_document1_file">Upload File</label>
                                                                  <input
                                                                    type="file"
                                                                    class="mb-30"
                                                                    id="additional_document1_file"
                                                                    name="additional_document1_file"
                                                                    accept="application/pdf,image/jpeg,image/png"
                                                                    @change="uploadAdditionalFile(0, $event)"
                                                                  />
                                                                </div>

                                                                <!-- Additional Document 2 -->
                                                                <div>
                                                                  <label>Additional Document 2</label>
                                                                  <input
                                                                    type="text"
                                                                    class="mb-10"
                                                                    name="additional_document2"
                                                                    id="additional_document2"
                                                                    v-model.lazy="additional_documents[1]"
                                                                  />
                                                                </div>
                                                                <div>
                                                                  <div>
                                                                    <a 
                                                                      v-if="doc2_filelink !== ''" 
                                                                      :href="doc2_filelink" 
                                                                      style="color: blue; cursor: pointer; font-weight: bold;" 
                                                                      target="_blank"
                                                                    >
                                                                      Download Here
                                                                    </a>
                                                                    <span v-if="doc2_filelink === ''"> No Attachment Found</span>
                                                                  </div>
                                                                  <br>
                                                                  <label for="additional_document2_file">Upload File</label>
                                                                  <input
                                                                    type="file"
                                                                    class="mb-30"
                                                                    id="additional_document2_file"
                                                                    name="additional_document2_file"
                                                                    accept="application/pdf,image/jpeg,image/png"
                                                                    @change="uploadAdditionalFile(1, $event)"
                                                                  />
                                                                </div>

                                                                <!-- Additional Document 3 -->
                                                                <div>
                                                                  <label>Additional Document 3</label>
                                                                  <input
                                                                    type="text"
                                                                    class="mb-10"
                                                                    name="additional_document3"
                                                                    id="additional_document3"
                                                                    v-model.lazy="additional_documents[2]"
                                                                  />
                                                                </div>
                                                                <div>
                                                                  <div>
                                                                    <a 
                                                                      v-if="doc3_filelink !== ''" 
                                                                      :href="doc3_filelink" 
                                                                      style="color: blue; cursor: pointer; font-weight: bold;" 
                                                                      target="_blank"
                                                                    >
                                                                      Download Here
                                                                    </a>
                                                                    <span v-if="doc3_filelink === ''"> No Attachment Found</span>
                                                                  </div>
                                                                  <br>
                                                                  <label for="additional_document3_file">Upload File</label>
                                                                  <input
                                                                    type="file"
                                                                    class="mb-30"
                                                                    id="additional_document3_file"
                                                                    name="additional_document3_file"
                                                                    accept="application/pdf,image/jpeg,image/png"
                                                                    @change="uploadAdditionalFile(2, $event)"
                                                                  />
                                                                </div>

                                                                <!--- New Added Additional Document End -->
                                                            </div>
                                                              <div class="col-lg-6">
                                                                <div>
                                                                    <label>First name:</label>
                                                                    <input type="text" v-model="first_name" name="ltn__name">
                                                                </div>
                                                                <div>
                                                                    <label>Last name:</label>
                                                                    <input type="text" v-model="last_name" name="ltn__lastname">
                                                                </div>
                                                                <div>
                                                                    <label>Position:</label>
                                                                    <input type="text" v-model="position" name="ltn__position">
                                                                </div>
                                                                <div>
                                                                    <label>Telephone Number:</label>
                                                                    <input type="text" v-model="tel_number" name="ltn__tel_number" maxlength="10" placeholder="Telephone Number (e.g. 02xxxxxxxx) ">
                                                                </div>
                                                                <div>
                                                                    <label>Mobile Number:</label>
                                                                    <input type="text" v-model="mobile_number" name="ltn__mobile_number" maxlength="12" placeholder="Mobile Number (e.g. 09xxxxxxxxx)">
                                                                </div>
                                                                <div>
                                                                    <label>Email Address:</label>
                                                                    <input type="email" v-model="email_address" name="ltn__email_address" placeholder="example@example.com">
                                                                </div>
                                                                <!-- New Added Social Media Links Start -->
                                                                  <div>
                                                                      <label for="links">Links (e.g. Website, Facebook, Youtube, etc.)</label>
                                                                      <textarea type="text" class="placeholderColor" name="links" v-model="linkInput" id="links" 
                                                                      placeholder="https://greatfoodsolution.com/,
  https://www.facebook.com/greatfoodsolution/,
  https://www.youtube.com/channel/UCgIfWa6ZEjoG4KywsoqERuA/">
                                                                          
                                                                      </textarea>
                                                                  </div>

                                                                <!-- New Added Social Media Links end -->
                                                            </div>
                                                        </div>
                                                        <div >
                                                            <button type="submit" @click="updateAccountDetails" class="btn theme-btn-1 btn-effect-1 text-uppercase">{{ submitting_accountdetails ? 'Updating...' : 'Update' }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <h2 id="changepass_section">Password Change</h2>
                                                <p v-if="show_changepass_error">{{ error_message }}</p>
                                                <div class="ltn__form-box">
                                                    <div class="mb-50">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <label>Current Password:</label>
                                                                <div class="input-item input-item-password mb-4">
                                                                    <input :type="(show_current_password ? 'text' : 'password')" v-model="current_password" name="curp">
                                                                    <i class="fas" :class="{ 'fa-eye': !show_current_password, 'fa-eye-slash': show_current_password }" @click="show_current_password = !show_current_password"></i>
                                                                </div>

                                                                <label>New Password:</label>
                                                                <div class="input-item input-item-password mb-4">
                                                                    <input :type="(show_new_password ? 'text' : 'password')" v-model="new_password" name="np">
                                                                    <i class="fas" :class="{ 'fa-eye': !show_new_password, 'fa-eye-slash': show_new_password }" @click="show_new_password = !show_new_password"></i>
                                                                </div>
                                                                <label>Confirm New Password:</label>
                                                                  <div class="input-item input-item-password mb-4">
                                                                    <input :type="(show_confirm_password ? 'text' : 'password')" v-model="confirm_password" name="np">
                                                                    <i class="fas" :class="{ 'fa-eye': !show_confirm_password, 'fa-eye-slash': show_confirm_password }" @click="show_confirm_password = !show_confirm_password"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="btn-wrapper">
                                                            <button type="submit" @click="changePassword" class="btn theme-btn-1 btn-effect-1 text-uppercase">{{ submitting_changepassword ? 'Saving...' : 'Save Changes' }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- PRODUCT TAB AREA END -->
                </div>
            </div>
        </div>
    </div>
    <!-- WISHLIST AREA START -->
    <Footer />
    <ConfirmDialogue ref="confirmDialogue" />
    <AlertDialogue ref="alertDialogue" />
    <AddToCartDialogue ref="addToCartDialogue" />
   <QuickviewDialogue ref="quickviewDialogue" />
  </div>
</template>
<style>
    .page.account-page input[type="file"] {
        display: block;
    }
    a.exaggerated_link {
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s all ease;
}
a.exaggerated_link:hover {
         color: var(--primary-color) !important; 
}
.address-list address.address {
    border-bottom: 1px solid #e1e1e1;
}
.orders table.table p.text-truncate {
    max-width: 250px;
}
.mb-50{
  margin-bottom: 50px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Account.vue